import { MatchingNote, MatchingNoteName } from '@marageti/z4-sdk/lib/standards';
import React, { useState } from 'react';
import { OutlinedIcons, TripMatchNotesCard } from '@marageti/z4-lib';
import { TripRequest } from '@marageti/z4-sdk/lib/travel';
import { IconButton } from '@mui/material';
import EditNotesModal from '../modals/trip-request-matching-notes-modal';

const { OutlinedPencilIcon: Edit } = OutlinedIcons;

export type MatchingNotes = Partial<Record<MatchingNoteName, MatchingNote>>;

type TripRequestMatchingNotesProps = {
  tripRequest?: TripRequest,
  onEditSuccess: () => void,
};

const TripRequestMatchingNotes = ({
  tripRequest,
  onEditSuccess,
}: TripRequestMatchingNotesProps) => {
  const [showEditModal, setShowEditModal] = useState(false);

  return (
    <>
      <TripMatchNotesCard
        title="Partner Notes"
        notes={tripRequest?.matchingNotes || {}}
        action={(
          <IconButton onClick={() => setShowEditModal(true)}>
            <Edit color="primary" fontSize="small" />
          </IconButton>
        )}
      />
      <EditNotesModal
        open={showEditModal}
        onClose={() => setShowEditModal(false)}
        tripRequest={tripRequest}
        onSuccess={onEditSuccess}
      />
    </>
  );
};

export default TripRequestMatchingNotes;
